<template>
  <div>
    <div class="py-4 ma-0 d-flex justify-space-between align-start">
      <div class="d-flex flex-column" style="max-width: 500px">
        <p class="caption blue-grey--text text--darken-3 font-weight-bold mb-0">
          {{ `${$t('routines.executed_by')}:` }}
          <span class="font-weight-medium">{{ executedBy }}</span>
        </p>
        <p class="caption blue-grey--text text--darken-3 font-weight-bold mb-0">
          {{ `${$t('routinesPrint.routine_link')}:` }}
          <span class="font-weight-medium">{{ routineLink }}</span>
        </p>
        <p class="caption blue-grey--text text--darken-3 font-weight-bold mb-0">
          {{ `${$t('routines.routine_description_title')}: ` }}
          <span class="font-weight-medium">{{ routineDescription }}</span>
        </p>
        <p
          v-if="hasChecklist"
          class="caption blue-grey--text text--darken-3 font-weight-bold mb-0"
        >
          {{ `${$t('checklist.checklist_one')}:` }}
          <span class="font-weight-medium">{{
            $t('routinesPrint.checklist_total_answers', {
              total: totalQuestions,
              answered: getChecklistBalance(),
            })
          }}</span>
        </p>
        <p
          v-if="routineScoreSummary"
          class="caption blue-grey--text text--darken-3 font-weight-bold mb-0"
          data-testid="detailRoutinePrint-row-score"
        >
          {{ `${$t('routines.scoring.score')}:` }}
          <span class="font-weight-medium">{{ formattedScorePercentage }}</span>
        </p>
        <p
          v-if="routineScoreSummary"
          class="caption blue-grey--text text--darken-3 font-weight-bold mb-0"
          data-testid="detailRoutinePrint-row-totalPoints"
        >
          {{ `${$t('routines.execution.total_points', { count: 2 })}:` }}
          <span class="font-weight-medium">{{ formattedTotalPoints }}</span>
        </p>
      </div>
      <div class="d-flex flex-column align-end">
        <p class="caption blue-grey--text text--darken-3 font-weight-bold mb-0">
          {{ `${$t('common.site_one')}:` }}
          <span class="font-weight-medium">{{ site }}</span>
        </p>
      </div>
    </div>
    <v-divider class="theme--print" />
  </div>
</template>

<script>
import config from '@/config'
import userMixin from '@/mixins/userMixin'
import { buildRoutineScoreSummary } from '@/components/Checklists/ChecklistReply/scoringDisplay'
import { formatLocalizedPoints } from '@/lib/formatLocalizedPoints'
import { formatScorePercentage } from '@/lib/formatScorePercentage'
import _ from 'lodash'

const maxDescriptionCharacters = 210

export default {
  name: 'DetailRoutinePrint',
  mixins: [userMixin],
  props: {
    routineExecution: {
      type: Object,
      required: true,
    },
    checklistItems: {
      type: Array,
    },
  },

  data() {
    return { maxDescriptionCharacters }
  },
  computed: {
    executedBy() {
      return this.getFullName(this.routineExecution?.createdBy) ?? null
    },
    routineDescription() {
      if (
        this.routineExecution?.description?.length >
        this.maxDescriptionCharacters
      ) {
        return `${this.routineExecution?.description.substring(
          0,
          this.maxDescriptionCharacters
        )}...`
      }

      return this.routineExecution?.description ?? null
    },
    routineLink() {
      const environmentURL = config.webAppURL
      return `${environmentURL}/routine-executions/${this.routineExecution?.id}`
    },

    site() {
      return this.routineExecution?.site?.name ?? null
    },

    hasChecklist() {
      return !_.isEmpty(this.checklistItems)
    },

    routineScoreSummary() {
      return buildRoutineScoreSummary(
        this.routineExecution,
        this.routineExecution?.checklistResponse
      )
    },

    formattedScorePercentage() {
      return formatScorePercentage(this.routineScoreSummary?.scorePercentage, {
        translate: (...args) => this.$t(...args),
      })
    },

    formattedTotalPoints() {
      return formatLocalizedPoints(this.routineScoreSummary?.totalPoints ?? 0)
    },

    totalQuestions() {
      return (
        this.checklistItems.filter(item => item.type !== 'separator')
          ?.length ?? 0
      )
    },
  },
  methods: {
    getChecklistBalance() {
      return this.checklistItems.filter(
        item =>
          (_.isNumber(item.response) && 'response' in item) ||
          !_.isEmpty(item.response) ||
          !_.isEmpty(item.responseImages) ||
          Boolean(item?.signature)
      )?.length
    },
  },
}
</script>
